import * as actionTypes from 'actions/driverManagementActions';

const initialState = {
  drivers: [],
  filter: {
    warehouse_security: true,
    warehouse_manager: true,
    warehouse_operation: true
  },
  loading: false,
  selectedDriver: [],
  formState: {
    open: false,
    edit: false,
    username: '',
    fullname: '',
    role: 'driver',
    avatar: '',
    email: '',
    role_name: '',
    note: '',
    ngay_bat_dau: new Date('2022/1/1')
  }
};

const driverManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_DRIVER: {
      return {
        ...state,
        drivers: action.drivers,
        loading: false,
        selectedDriver: []
      };
    }

    case actionTypes.SET_FILTER: {
      return {
        ...state,
        filter: { ...state.filter, ...action.filter }
      };
    }

    case actionTypes.SET_LOADING: {
      return {
        ...state,
        loading: action.loading
      };
    }

    case actionTypes.SET_SELECTED_DRIVER: {
      return {
        ...state,
        selectedDriver: action.selected
      };
    }

    case actionTypes.UPDATE_FORM: {
      return {
        ...state,
        formState: { ...state.formState, ...action.formState }
      };
    }

    default: {
      return state;
    }
  }
};

export default driverManagementReducer;
